module.exports = __webpack_public_path__ + "img/nailcare.77bd6742.svg";